import { render } from "./ClinicMutiraoTab.vue?vue&type=template&id=2967e21e&scoped=true"
import script from "./ClinicMutiraoTab.vue?vue&type=script&lang=js"
export * from "./ClinicMutiraoTab.vue?vue&type=script&lang=js"

import "./ClinicMutiraoTab.vue?vue&type=style&index=0&id=2967e21e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2967e21e"]])

export default __exports__